module.exports = __webpack_public_path__ + "img/kefu1.61035b5f.png";